import { useMemo } from 'react'
import { useWallets } from '@towns/privy'

export function useConnectedNonPrivyWallets() {
    const { wallets, ready } = useWallets()

    return {
        ready,
        wallets: useMemo(() => {
            return wallets.filter((wallet) => wallet.walletClientType !== 'privy')
        }, [wallets]),
    }
}
